import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, CircularProgress, Typography, Alert } from '@mui/material'; // Added Typography
import ProfileSettings from '../../ProfileSettings'; 
// import { useToast } from '../../hooks/use-toast'; // Removed useToast

const ProfileSettingsDialog = ({
  open,
  user, 
  profileData, 
  onSave, 
  onClose, 
  isSaving, 
  saveError, // New prop to pass save error message from parent
}) => {
  // const { toast } = useToast(); // Removed useToast

  if (!open) return null;

  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      // Prevent closing via backdrop or escape if profile is mandatory
      // Parent component should manage if a toast/alert is shown for this.
      // For example, OnboardingRedirect shows a toast.
      return;
    }
    if (onClose) {
      onClose();
    }
  };
  
  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown 
    >
      <DialogTitle sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}>
        Complete Your Profile
      </DialogTitle>
      <DialogContent dividers sx={{ p: { xs: 1, sm: 2, md: 3 } }}> {/* Add some padding */}
        {isSaving && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3, flexDirection: 'column' }}>
            <CircularProgress />
            <Typography sx={{ mt: 2 }} color="text.secondary">Saving profile...</Typography>
          </Box>
        )}
        {saveError && !isSaving && ( // Show save error if not currently saving
            <Alert severity="error" sx={{ mb: 2 }}>{saveError}</Alert>
        )}
        {!isSaving && user && ( 
          <ProfileSettings
            profileData={profileData || user}
            onSave={onSave} 
            isDialogMode={true} 
            // Pass a specific error to ProfileSettings if it can display it internally,
            // or rely on the Alert above.
            // externalError={saveError} 
          />
        )}
        {!isSaving && !user && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
                <Typography color="error">User data not available. Cannot load profile form.</Typography>
            </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ProfileSettingsDialog;
